import { react } from "react";
import Introduction from "../components/Introduction";
import HeroSection from "../components/HeroSection";

const About = () => {
    return (
        <div className="newspaper-container-wrapper">
            <HeroSection pageType="other" />
            <Introduction />
        </div>
    );

};

export default About;
